/*
 * Copyright 2025 Intuition Robotics ltd
 */
/*
 * A typescript & react boilerplate with api call example
 *
 * Copyright (C) 2018  Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {ThunderDispatcher} from "@intuitionrobotics/thunderstorm/frontend";
import {
	Module
} from "@intuitionrobotics/ts-common";
import {OnWindowResize} from "../app/App";

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const breakpoints: { [bp in Breakpoint]: number } = {
	xs: 0,
	sm: 500,
	md: 768,
	lg: 992,
	xl: 1200
};


export interface OnScreenSizeChange {
	__onScreenSizeChange: () => void;
}

export const dispatch_onScreenSizeChange = new ThunderDispatcher<OnScreenSizeChange, '__onScreenSizeChange'>('__onScreenSizeChange');

export class MediaQueryModule_Class
	extends Module
	implements OnWindowResize {

	private bp: Breakpoint = 'lg';

	__onWindowResize = () => {
		this.dispatchScreenSize();
	};

	getScreenWidth = () => {
		return window.innerWidth;
	}

	private dispatchScreenSize = () => {
		const screenWidth = this.getScreenWidth();
		const newBreakpoint = (Object.keys(breakpoints) as Array<Breakpoint>)
			.filter(bp => breakpoints[bp] <= screenWidth)
			.slice(-1)
			.pop() || 'lg';

		const breakpointChanged = this.bp !== newBreakpoint;
		this.bp = newBreakpoint;
		if (!breakpointChanged)
			return;

		dispatch_onScreenSizeChange.dispatchUI();
	}

	screenLessThan = (bp: Breakpoint | number) => {
		switch(typeof bp){
			case "number":
				return this.getScreenWidth() < bp;
			case "string":
				return this.getScreenWidth() < breakpoints[bp];
			default:
				// assuming screen will be lg most of the cases
				return false;
		}
	}

}


export const MediaQueryModule = new MediaQueryModule_Class("MediaQueryModule");
